module.exports = __webpack_public_path__ + "img/easy-fiesta-fish.42384c9f.jpg";